module.exports = "<app-documento-entrada-detalle-list [documento]=\"documento\"></app-documento-entrada-detalle-list>"


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/services/testing/testing.component.html
// module id = ../../../../../src/app/services/testing/testing.component.html
// module chunks = main